import { render } from "./ArtistPage.vue?vue&type=template&id=38677cb0&scoped=true"
import script from "./ArtistPage.vue?vue&type=script&lang=js"
export * from "./ArtistPage.vue?vue&type=script&lang=js"

import "./ArtistPage.vue?vue&type=style&index=0&id=38677cb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38677cb0"]])

export default __exports__